/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Seo_Description_CsInputs */

const cs_form_seo_description_cs = /** @type {(inputs: Form_Seo_Description_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO popis (CS)`)
};

const en_form_seo_description_cs = /** @type {(inputs: Form_Seo_Description_CsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SEO description (CS)`)
};

/**
* | output |
* | --- |
* | "SEO description (CS)" |
*
* @param {Form_Seo_Description_CsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_seo_description_cs = /** @type {((inputs?: Form_Seo_Description_CsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Seo_Description_CsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_seo_description_cs(inputs)
	return cs_form_seo_description_cs(inputs)
});